import _ from 'underscore'

export default {
  namespaced: true,
  state () {
    return {
      list: []
    }
  },
  getters: {
    list (state) {
      return state.list
    },
    getOrder: (state) => (token) => {
      return _.find(state.list, function (order) {
        return order.token === token
      })
    },
    getBox: (state, getters) => (token, boxIndex) => {
      return getters.getOrder(token).json.boxes[boxIndex]
    },
    selectedTokenList (state) {
      return _.chain(state.list)
        .filter(function (order) {
          return order.isOutput
        })
        .map(function (order) {
          return order.token
        })
        .value()
    },
    outputSelectedCount (state) {
      let selected = _.filter(state.list, function (order) {
        return order.isOutput
      })
      return selected.length
    }
  },
  mutations: {
    clearList (state) {
      state.list = []
    },
    setList (state, list) {
      state.list = _.map(list, function (order) {
        return Object.assign({
          isOutput: false
        }, order)
      })
    },
    hideOrder (state, token) {
      state.list.splice(_.findIndex(state.list, {
        token: token
      }), 1)
    },
    hideSelected (state) {
      state.list = _.filter(state.list, function (order) {
        return order.isOutput === false
      })
    },
    clearSelected (state) {
      state.list = _.map(state.list, function (order) {
        return Object.assign(order, {
          isOutput: false
        })
      })
    },
    addOrder (state, order) {
      state.list.push(order)
    },
    updateOrder (state, payload) {
      state.list.splice(_.findIndex(state.list, {
        token: payload.token
      }), 1, payload.order)
    },
    setOutput (state, payload) {
      _.chain(state.list)
        .filter(function (order) {
          return order.token === payload.token
        })
        .each(function (order) {
          order.isOutput = payload.isOutput
        })
    },
    updateBoard (state, payload) {
      let order = _.find(state.list, function (order) {
        return order.token === payload.token
      })
      let board = order.json.boxes[payload.boxIndex].order_faces[payload.faceIndex].order_boards[payload.boardIndex]
      Object.assign(board, payload.board)
    }
  },
  actions: {
    clearList ({
      commit
    }) {
      commit('clearList')
    },
    setList ({
      commit
    }, list) {
      commit('setList', list)
    },
    hideOrder ({
      commit
    }, token) {
      commit('hideOrder', token)
    },
    hideSelected ({
      commit
    }) {
      commit('hideSelected')
    },
    clearSelected ({
      commit
    }) {
      commit('clearSelected')
    },
    addOrder ({
      commit
    }, order) {
      commit('addOrder', order)
    },
    updateOrder ({
      commit
    }, payload) {
      commit('updateOrder', payload)
    },
    setOutput ({
      commit
    }, payload) {
      commit('setOutput', payload)
    },
    updateBoard ({
      commit
    }, payload) {
      commit('updateBoard', payload)
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/List/store.js